import { profileEventEmitter, ProfileEvents } from '@rango-dev/internal-profile';
import { widgetEventEmitter, WidgetEvents } from '@rango-dev/widget-embedded';
import { useEffect } from 'react';

import { pushToDataLayer } from '../analytics/dataLayer';
import { GA4Events } from '../analytics/ga4Events';
import { handleProfileEvent } from '../analytics/profileEventAdapter';
import {
  handleQuoteEvent,
  handleRouteEvent,
  handleStepEvent,
  handleUiEvent,
  handleWalletEvent,
} from '../analytics/widgetEventAdapter';

/**
 * Subscribes to every widget event channel and forwards them to GA4 via the
 * analytics adapter (camelCase widget events -> snake_case dataLayer pushes).
 * This is the single place the dapp translates widget events into analytics.
 */
export function useSubscribeToEvents(): void {
  useEffect(() => {
    pushToDataLayer(GA4Events.APP_LOADED);

    widgetEventEmitter.on(WidgetEvents.UiEvent, handleUiEvent);
    widgetEventEmitter.on(WidgetEvents.QuoteEvent, handleQuoteEvent);
    widgetEventEmitter.on(WidgetEvents.WalletEvent, handleWalletEvent);
    widgetEventEmitter.on(WidgetEvents.RouteEvent, handleRouteEvent);
    widgetEventEmitter.on(WidgetEvents.StepEvent, handleStepEvent);

    profileEventEmitter.on(ProfileEvents.ProfileEvent, handleProfileEvent);

    return () => {
      widgetEventEmitter.off(WidgetEvents.UiEvent, handleUiEvent);
      widgetEventEmitter.off(WidgetEvents.QuoteEvent, handleQuoteEvent);
      widgetEventEmitter.off(WidgetEvents.WalletEvent, handleWalletEvent);
      widgetEventEmitter.off(WidgetEvents.RouteEvent, handleRouteEvent);
      widgetEventEmitter.off(WidgetEvents.StepEvent, handleStepEvent);

      profileEventEmitter.off(ProfileEvents.ProfileEvent, handleProfileEvent);
    };
  }, []);
}
